<template>
  <div class="search-container">
    <input 
      type="text" 
      v-model="searchQuery" 
      @input="onSearchInput" 
      :placeholder="placeholder || $t('activities.search')" 
      class="search-input"
    >
    <div class="search-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="7" stroke="#979797" stroke-width="2" />
        <path d="M20 20L17 17" stroke="#979797" stroke-width="2" stroke-linecap="round" />
      </svg>
    </div>
    <button v-if="searchQuery" @click="clearSearch" class="search-clear">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="#979797" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'UiSearchInput',

  props: {
    placeholder: {
      type: String,
      default: null
    },
    modelValue: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      searchQuery: this.modelValue || this.value
    }
  },

  watch: {
    modelValue (newValue) {
      this.searchQuery = newValue
    },

    value (newValue) {
      this.searchQuery = newValue
    },

    searchQuery (newValue) {
      this.$emit('update:modelValue', newValue)
      this.$emit('input', newValue)
    }
  },

  methods: {
    onSearchInput () {
      this.$emit('search-input', this.searchQuery)
    },

    onSearchClick () {
      this.$emit('search-click', this.searchQuery)
    },

    clearSearch () {
      this.searchQuery = ''
      this.$emit('search-input', '')
      this.$emit('clear')
    }
  }
}
</script>

<style lang="scss" scoped>
.search-container {
  position: relative;
  width: 100%;
  max-width: 320px;
}

.search-input {
  width: 100%;
  padding: 12px 16px 12px 48px;
  border: 1px solid #e1e5e9;
  border-radius: 10px;
  font-size: 14px;
  background-color: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);

  &:focus {
    outline: none;
    border-color: #5ebe40;
    box-shadow: 0 0 0 3px rgba(94, 190, 64, 0.15);
  }

  &::placeholder {
    color: #999;
    font-style: italic;
  }

  &:not(:placeholder-shown) {
    padding-right: 44px;
  }
}

.search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 1;

  svg {
    width: 20px;
    height: 20px;
  }

  svg circle,
  svg path {
    stroke: #999;
    transition: stroke 0.2s ease;
  }
}

.search-clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  z-index: 2;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  &:focus {
    outline: none;
    background-color: rgba(0, 0, 0, 0.1);
  }

  svg {
    width: 16px;
    height: 16px;
  }

  svg path {
    stroke: #999;
    transition: stroke 0.2s ease;
  }

  &:hover svg path {
    stroke: #666;
  }
}

.search-container:hover {
  .search-input {
    border-color: #bbb;
  }

  .search-icon svg circle,
  .search-icon svg path {
    stroke: #777;
  }
}

.search-input:focus + .search-icon svg circle,
.search-input:focus + .search-icon svg path {
  stroke: #5ebe40;
}

@media (max-width: 768px) {
  .search-container {
    max-width: 100%;
    min-width: 200px;
  }
  
  .search-input {
    padding: 12px 16px 12px 48px;
    font-size: 16px;
  }
}
</style>